/**
 * 菜单路由拦截方法
 */
class MenuClickBlock {

    // 结构为{path:"",message:"",isBlock:true}
    menusBlock = [];
    constructor(menusBlock) {
        this.menusBlock = menusBlock;
        
        // 判断刷新监听
        window.addEventListener("beforeunload", async (e)=>{
            console.log(e)
            const result = await this.clickIsBlock(window.location.hash.replace('#',''));
            if (result) {
                // 浏览器兼容问题
                if (typeof e.defaultPrevented === 'function') {
                    e.defaultPrevented();
                }else {
                    e.returnValue = false;
                }
            }
        });
    }

    // 增加拦截信息
    addMenuClick(blockInfo={path:"",message:"",isBlock:false}) {
        const findOne =  this.menusBlock.find(item=>item.path===blockInfo.path);
        if (blockInfo&&!!findOne) {
            findOne["message"] = blockInfo.message;
            findOne["isBlock"] = blockInfo.isBlock;
            this.menusBlock[this.menusBlock.findIndex(item=>item.path===blockInfo.path)] = findOne;
        }else{
            this.menusBlock.push(blockInfo);
        }
    }

    // 修改拦截状态
    changeBlockStatus(path,status) {
        if (path&&(status!==undefined|| status!==null)) {
            this.menusBlock = this.menusBlock.map(item=>{
                if (item.path===path) {
                    item.isBlock = status
                }
                return item
            })
        }else{
            console.warn("path或status值为空");
        }
    }

    // 菜单点击拦截方法
    clickIsBlock(clickMenu) {
        return new Promise((resolve,reject)=>{
            if (Array.isArray( this.menusBlock)&& this.menusBlock.length>0) {
                this.menusBlock.forEach(item => {
                    // if (item.isBlock&&window.location.hash.replace("#",'')!==clickMenu.path) {
                    if (item.isBlock&&item.path.replace("#",'')!==clickMenu.path) {
                        const result =  window.confirm(item.message);
                        if (result) {
                            item.isBlock = false;
                            resolve(false);
                        }else{
                            resolve(true);
                        }
                    }
                });
                resolve(false);
            }
            resolve(false);
        })
    }

    destroy() {
        window.removeEventListener("beforeunload", async (e)=>{
            const result = await this.clickIsBlock(window.location.hash.replace('#',''))
            if (result) {
                // 浏览器兼容问题
                if (typeof e.defaultPrevented === 'function') {
                    e.defaultPrevented();
                }else {
                    e.returnValue = false;
                }
            }
        })
        this.menusBlock = [];
    }
}
export const menuBlock = new MenuClickBlock([]);
window.menuBlock = menuBlock;